import axios from 'axios';
import config from '../config';


let external_key = "";

export const getConfig = async (userid) => {
    const configReq = {
        process_id: "cekilis",
        user_id: userid,
        recaptcha: "test",
    }
    const response = await axios.post(config.apiBaseUrlAdvanced, configReq);
    return await response.data;
}


export const getUser = async (userid) => {
    const userReq = {
        process_id: "get-user",
        user_id: userid,
        recaptcha: "test"
    }
    const response = await axios.post(config.apiBaseUrlAdvanced, userReq);
    return await response.data;
}

export const getLottery = async (userid) => {
    const lotteryReq = {
        process_id: "getc-lottery",
        user_id: userid,
        recaptcha: "test"
    }
    const response = await axios.post(config.apiBaseUrlAdvanced, lotteryReq);
    return await response.data;
}

export const getLotteryTicket = async (userid, tier,process_id) => {
    const lotteryTicketReq = {
        process_id: process_id,
        recaptcha: "test",
        tier: tier,
        user_id: userid
    }
    const response = await axios.post(config.apiBaseUrl2, lotteryTicketReq);
    return await response.data;
}

export const adminLogin = async (username, password) => {
    const userLoginrequest = {
        username: username,
        password: password
    }

    const loginresponse = await axios.post(config.adminApi + "login", userLoginrequest);
    external_key = loginresponse.data.external_key;
    console.log("external_key", external_key);
    return await loginresponse.data;
}


export const setCss = async (cssdata) => {
    try {
        // Validate input data
        if (!cssdata || typeof cssdata !== 'object') {
            throw new Error('Invalid CSS data');
        }
        const setcss = {
            data: cssdata
           
        };


        const response = await axios.post(config.apiSetCss, JSON.stringify(setcss), {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });


        // Check if response exists and has data
        if (!response || !response.data) {
            throw new Error('Invalid API response');
        }

        // Return success response
        return {
            success: true,
            message: 'CSS başarıyla güncellendi',
            data: response.data
        };

    } catch (error) {
        console.error('CSS update error:', error);

        // Return error response
        return {
            success: false,
            message: error.response?.data?.message || error.message || 'CSS güncellenirken bir hata oluştu'
        };
    }

}

export const getCss = async () => {
    const responsegetcss = await axios.post(config.apiBaseUrlAdvanced,
        {
            process_id: "get-lottery-css",
            user_id: "",
            recaptcha: "test",
        },
        {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

    return await responsegetcss.data;
}


export const isUser = async (name, token) => {
    const isUserRequest = {
        username: name,
        key: config.apiKey,
    }
    const responseisuser = await axios.post(config.apiSiraliistek, isUserRequest, { 
        headers: { 
            'key': config.apiKey,
            'Content-Type': 'application/json'
        }, 
        maxBodyLength: Infinity 
    });
    return await responseisuser.data;
}

export const myTickets = async (tier, user_id) => {
    const isUserRequest = {
        tier: tier,
        user_id: user_id
    }
    const responseisuser = await axios.post(config.myTickets, isUserRequest, { headers: {  contentType: 'application/json' }, maxBodyLength: Infinity });
    return await responseisuser.data;
}
